if (!customElements.get('wlsn-buybox-description')) {
  class WLSNBuyboxDescription extends HTMLElement {
    constructor() {
      super();

      this.bindMethods = {
        onDescriptionToggleClick: this._onDescriptionToggleClick.bind(this),
      };
    }

    /**
     * Get elements
     * @returns {Object} - Object containing DOM element references
     */
    get elements() {
      return {
        descriptionToggle: this.querySelector('[data-action="toggle-description"]'),
        descriptionInner: this.querySelector('.js-description-text-inner'),
      };
    }

    /**
     * Connected callback method
     * @returns {void}
     */
    connectedCallback() {
      const { descriptionToggle } = this.elements;
      if (descriptionToggle) {
        descriptionToggle.addEventListener('click', this.bindMethods.onDescriptionToggleClick);
      }
    }

    /**
     * Disconnected callback method
     * @returns {void}
     */
    disconnectedCallback() {
      const { descriptionToggle } = this.elements;
      if (descriptionToggle) {
        descriptionToggle.removeEventListener('click', this.bindMethods.onDescriptionToggleClick);
      }
    }

    /**
     * Handle description toggle click – expand or collapse
     * @param {Event} event - Event object
     * @returns {void}
     */
    _onDescriptionToggleClick(event) {
      event.preventDefault();
      if (this.dataset.expanded === 'true') {
        this._collapseDescription();
      } else {
        this._expandDescription();
      }
    }

    /**
     * Expand description (show full text, switch to Read less)
     * @returns {void}
     */
    _expandDescription() {
      const { descriptionInner, descriptionToggle } = this.elements;
      if (!descriptionInner || !descriptionToggle) return;

      const fullText = descriptionInner.dataset.descriptionFull;
      if (!fullText) return;

      descriptionInner.textContent = fullText;
      descriptionToggle.textContent = descriptionToggle.dataset.labelLess || 'Read less';
      this.dataset.expanded = 'true';
    }

    /**
     * Collapse description (show truncated text, switch to Read more)
     * @returns {void}
     */
    _collapseDescription() {
      const { descriptionInner, descriptionToggle } = this.elements;
      if (!descriptionInner || !descriptionToggle) return;

      const truncatedText = descriptionInner.dataset.descriptionTruncated;
      if (!truncatedText) return;

      descriptionInner.textContent = truncatedText;
      descriptionToggle.textContent = descriptionToggle.dataset.labelMore || 'Read more';
      this.dataset.expanded = 'false';
    }
  }

  customElements.define('wlsn-buybox-description', WLSNBuyboxDescription);
}
